export default __webpack_public_path__ + "static/decentraland-6503bad5578b00f8419ca0b43e62a486.png";